import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from 'ngx-bootstrap/ng2-bootstrap';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { FacultyDetailsComponent } from './academics/facultyDetails.component';
import { CourseOfferedComponent } from './academics/courseOffered.component';
import { CampusTourComponent } from './campusTour/campusTour.component';
import { ContactComponent } from './contact/contact.component';
import { NewsComponent } from './news/news.component';
import { CalendarOfEventsComponent } from './home/calendarOfEvents.component';
import { EligibilityAdmissionComponent } from './admission/eligibilityAdmission.component';
import { NormsAdmissionComponent } from './admission/normsAdmission.component';
import { DocumentsAdmissionComponent } from './admission/documentsAdmission.component';
import { EligibilityPucExamComponent } from './admission/eligibilityPucExam.component';
import { RulesRegulationsComponent } from './academics/rulesRegulations.component';
import { TestsComponent } from './academics/tests.component';
import { GuidelinesComponent } from './academics/guidelines.component';
import { CodeOfConductComponent } from './academics/codeOfConduct.component';
import { AttendanceComponent } from './academics/attendance.component';
import { PrincipalDeskComponent } from './principalDesk/principalDesk.component';
import { AchievementsComponent } from './academics/achievements.component';
import { PhysicsComponent } from './academics/physics.component';
import { ChemistryComponent } from './academics/chemistry.component';
import { MathsComponent } from './academics/maths.component';
import { BioComponent } from './academics/bio.component';
import { ElectronicsComponent } from './academics/electronics.component';
import { LanguageComponent } from './academics/langauge.component';


const appRoutes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'eligibilityAdmission', component: EligibilityAdmissionComponent },
  { path: 'normsAdmission', component: NormsAdmissionComponent },
  { path: 'documentsAdmission', component: DocumentsAdmissionComponent },
  { path: 'eligibilityPucExam', component: EligibilityPucExamComponent },
  { path: 'facultyDetails', component: FacultyDetailsComponent },
  { path: 'courseOffered', component: CourseOfferedComponent },
  { path: 'rules', component: RulesRegulationsComponent },
  { path: 'tests', component: TestsComponent },
  { path: 'guidelines', component: GuidelinesComponent },
  { path: 'codeOfConduct', component: CodeOfConductComponent },
  { path: 'attendance', component: AttendanceComponent },
  { path: 'campusTour', component: CampusTourComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'news', component: NewsComponent },
  { path: 'calendarOfEvents', component: CalendarOfEventsComponent },
  { path: 'principalDesk', component: PrincipalDeskComponent },
  { path: 'achievements', component: AchievementsComponent },
  { path: 'physics', component: PhysicsComponent },
  { path: 'chemistry', component: ChemistryComponent },
  { path: 'maths', component: MathsComponent },
  { path: 'bio', component: BioComponent },
  { path: 'electronics', component: ElectronicsComponent },
  { path: 'language', component: LanguageComponent },



  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    FacultyDetailsComponent,
    CourseOfferedComponent,
    CampusTourComponent,
    ContactComponent,
    NewsComponent,
    CalendarOfEventsComponent,
    EligibilityAdmissionComponent,
    NormsAdmissionComponent,
    DocumentsAdmissionComponent,
    EligibilityPucExamComponent,
    RulesRegulationsComponent,
    TestsComponent,
    GuidelinesComponent,
    CodeOfConductComponent,
    AttendanceComponent,
    PrincipalDeskComponent,
    AchievementsComponent,
    PhysicsComponent,
    ChemistryComponent,
    MathsComponent,
    BioComponent,
    ElectronicsComponent,
    LanguageComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes,{useHash:true}),
    AlertModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/app.module.ts